import { memo } from "react";

import newTheme from "@/new_theme";
import { cx } from "@/utils";
import ReactWordcloud from "@cyberblast/react-wordcloud";

import { BaseWidget } from "../BaseWidget";
import { sumArray } from "../helpers";

import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import styles from "./WordCloudWidget.module.css";

const WORD_CLOUD_COLORS = [
  newTheme["primary-600"],
  newTheme["pink-600"],
  newTheme["blue-600"],
];

const WORD_CLOUD_SETTINGS = {
  deterministic: true,
  colors: WORD_CLOUD_COLORS,
  enableTooltip: true,
  fontFamily: newTheme.fonts.header,
  fontWeight: 500,
  fontSizes: [30, 80, 150],
  rotations: 3,
  rotationAngles: [0],
};

const hasData = (data) =>
  data &&
  data.map((d) => Object.keys(d.words || {}).length).reduce(sumArray, 0) > 0;

const WordCloud = ({ className, ...props }) => {
  const _hasData = hasData(props.data);

  const totalSources = props.data && props.data.length;
  const wordsWithFrequencies =
    _hasData &&
    props.data.reduce((all, { words }) => {
      if (words) {
        Object.entries(words).forEach(([word, freq]) => {
          if (!all[word]) all[word] = 0;
          all[word] += freq / totalSources;
        });
      }

      return all;
    }, {});

  const words =
    wordsWithFrequencies &&
    Object.entries(wordsWithFrequencies).map(([w, f]) => {
      return {
        text: w,
        value: f,
      };
    });

  return (
    <BaseWidget {...props} hasData={_hasData}>
      {_hasData && (
        <div className={cx(className, styles.chartWrapper)}>
          <ReactWordcloud words={words} options={WORD_CLOUD_SETTINGS} />
        </div>
      )}
    </BaseWidget>
  );
};

export const WordCloudWidget = memo(WordCloud);
